/* @flow */

import _ReportOutputParams from './ReportOutputParams';

export default _ReportOutputParams;



// WEBPACK FOOTER //
// ./src/components/ReportOutputParams/index.js